/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface AdminDataOrganisationDTO
 */
export interface AdminDataOrganisationDTO  {
    /**
     * 
     * @type {number}
     * @memberof AdminDataOrganisationDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataOrganisationDTO
     */
    changed?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AdminDataOrganisationDTO
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminDataOrganisationDTO
     */
    deskman?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDataOrganisationDTO
     */
    editorialStatus?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDataOrganisationDTO
     */
    hidden?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDataOrganisationDTO
     */
    origin?: string;
}

/**
 * Check if a given object implements the AdminDataOrganisationDTO interface.
 */
export function instanceOfAdminDataOrganisationDTO(value: object): value is AdminDataOrganisationDTO {
    return true;
}

export function AdminDataOrganisationDTOFromJSON(json: any): AdminDataOrganisationDTO {
    return AdminDataOrganisationDTOFromJSONTyped(json, false);
}

export function AdminDataOrganisationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminDataOrganisationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'changed': json['changed'] == null ? undefined : (new Date(json['changed'])),
                'created': json['created'] == null ? undefined : (new Date(json['created'])),
                  'deskman': json['deskman'] == null ? undefined : json['deskman'],
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
                  'hidden': json['hidden'] == null ? undefined : json['hidden'],
                  'origin': json['origin'] == null ? undefined : json['origin'],
    };
}

export function AdminDataOrganisationDTOToJSON(json: any): AdminDataOrganisationDTO {
    return AdminDataOrganisationDTOToJSONTyped(json, false);
}

export function AdminDataOrganisationDTOToJSONTyped(value?: AdminDataOrganisationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'changed': value['changed']?.toISOString(),
        'created': value['created']?.toISOString(),
        'deskman': value['deskman'],
        'editorialStatus': value['editorialStatus'],
        'hidden': value['hidden'],
        'origin': value['origin'],
    };
}


